import {useCallback} from 'react';
import {EventAction, EventCategory, EventNames} from 'modules/google-analytics/constants';
import {IAnalyticsMeta} from 'core/types';
import {sendGtagEvent} from 'hooks/analytics/gtag/sendGtagEvent';
import {IProductShort} from 'modules/products/types';
import {NEXT_PUBLIC_MASTER_HOST} from 'core/helpers/env';
import {useGtagEventLocation} from 'hooks/analytics/gtag/helpers/useGtagEventLocation';

export const useProductLabelClickAnalytics = () => {
    const {eventLocation} = useGtagEventLocation();

    return useCallback(
        // eslint-disable-next-line @typescript-eslint/naming-convention
        (id: IProductShort['id'], analytics: IAnalyticsMeta = {}, url?: string) =>
            () => {
                const dataLayerList = {
                    event: EventNames.OWOX,
                    eventCategory: EventCategory.Interactions,
                    eventAction: EventAction.Click,
                    eventLabel: 'product | shield',
                    eventLocation,
                    eventContext: `${analytics.listName ?? eventLocation ?? ''} | ${id} | ${NEXT_PUBLIC_MASTER_HOST}${url}`,
                };

                sendGtagEvent(dataLayerList);
            },
        [eventLocation],
    );
};
